import { createFileRoute, notFound } from "@tanstack/react-router";
import { BmiPageShell } from "@/components/bmi/BmiPageShell";
import { generateBmi } from "@/lib/bmi/generator";
import { parseHeight } from "@/lib/bmi/clusters";
import { leafHead } from "@/lib/seo/leaf-head";
import { bmiPageScripts } from "@/lib/bmi/schemas";

export const Route = createFileRoute("/bmi-calculator-for-{$height}")({
  loader: ({ params }) => {
    const raw = (params as { height: string }).height;
    const m = raw.match(/^(\d+)-feet-(\d+)-inches-tall$/);
    if (!m) throw notFound();
    const h = parseHeight(m[1], m[2]);
    if (!h) throw notFound();
    return generateBmi({ cluster: "C", height: h });
  },
  head: ({ loaderData }) => {
    if (!loaderData) return { meta: [{ title: "Not found" }, { name: "robots", content: "noindex" }] };
    return leafHead({
      path: loaderData.path,
      title: loaderData.meta.title,
      description: loaderData.meta.description,
      ogType: "article",
      scripts: bmiPageScripts(loaderData),
    });
  },
  component: Comp,
  notFoundComponent: () => (
    <div className="mx-auto max-w-lg p-8 text-center">
      <h1 className="text-2xl font-bold">Height not covered</h1>
      <p className="mt-2 text-muted-foreground">See the <a className="text-primary underline" href="/bmi-calculator">full BMI directory</a> for supported heights.</p>
    </div>
  ),
  errorComponent: () => (
    <div className="mx-auto max-w-lg p-8 text-center"><h1 className="text-2xl font-bold">Something went wrong</h1></div>
  ),
});

function Comp() {
  const data = Route.useLoaderData();
  return <BmiPageShell data={data} />;
}